import { render, staticRenderFns } from "./RegisterBasic.vue?vue&type=template&id=2b348384&scoped=true"
import script from "./RegisterBasic.vue?vue&type=script&lang=js"
export * from "./RegisterBasic.vue?vue&type=script&lang=js"
import style0 from "./RegisterBasic.vue?vue&type=style&index=0&id=2b348384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b348384",
  null
  
)

export default component.exports